export const FOREIGN_TOKEN: string = 'astrea-token-foreign';
export const FOREIGN_HEADER: string = 'X-Token-Foreign';
